import { StepProps } from "~/components/organisms/step";
import { ContactFields } from "../contact-fields";

export function Owner({ control }: { control: StepProps["control"] }) {
  return (
    <>
      <ContactFields
        name="team.owner"
        control={control}
        nameLabel="Owner Name"
        telephoneLabel="Owner Telephone"
        emailLabel="Owner Email"
      />
    </>
  );
}
